<template>
    <div class="SubstationManagement subpostation" >
        <div id="left">
            <div class="Placeholder"></div>
            <div id="areachart" class="row-center" style=" justify-content: space-between;">
                <div class="EchartsLeft" >
                    <div class="title">
                        <el-dropdown trigger="click" class="dropdown" @command="handleCommand"  placement="bottom-start">
                            <span class="el-dropdown-link">
                                {{transform}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item,index) in transformerList" :key="index" :command="item">{{item.device_name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="tab">
                            <span :class="tabSdx == 0? 'tabSpan':''" @click="changeTab(0)">负载</span>
                            <span :class="tabSdx == 1? 'tabSpan':''" @click="changeTab(1)">温度</span>
                        </div>
                    </div>
                    <!-- <div class="capacity" ><span>容量：630kVA</span></div> -->
                    <div class="tabCharts" v-if="tabSdx == 0">
                        <div id="my_echarts" style="height:100%;width:100%"></div>
                    </div>
                    <div class="tabCharts" v-if="tabSdx == 1">
                        <div id="my_echarts1" style="height:100%;width:100%"></div>
                    </div>
                </div>
                <div class="EchartsRight">
                    <div class="title">
                        <el-dropdown trigger="click" class="dropdown" @command="handleCommand2"  placement="bottom-start">
                            <span class="el-dropdown-link">
                                {{transform2}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item,index) in loopList" :key="index" :command="item">{{item.loopName}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="tabCharts" v-if="!echartshow">
                        <div id="my_echarts2" style="height:100%;width:100%" ></div>
                    </div>
                    <div class="tabCharts" v-else>
                        <div  class="nodata" ><img src="../../assets/img/not_found_data.png" alt=""></div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="rightYuanqu">
            <div class="top">
                <div class="title">
                    <img :src="AreaInfo.areaImg" alt="">
                    <div class="titler">
                        <div class="titleName">{{AreaInfo.areaName}}</div>
                        <span @click.stop="isShowArea = !isShowArea" >切换<img src="../../assets/img/change0.png" alt=""></span>
                        <div v-if="isShowArea" ref="area">
                            <Href @closedArea='closedArea' ></Href>
                        </div>
                    </div>
                    <button @click="backYuanqu">返回园区</button>
                </div>
                <div class="motion">自{{startTime}}起，已安全运行 <span>{{projectTime}}</span> 天</div>
                <div class="area row-center">
                    <div class="item">
                        <div class="name">平均负载率</div>
                        <div class="num">47.2%</div>
                    </div>
                    <div class="item">
                        <div class="name">装机总容量</div>
                        <div class="num">800kVA</div>
                    </div>
                    <div class="item">
                        <div class="name">电压等级</div>
                        <div class="num">10/0.4kV</div>
                    </div>
                    <div class="item">
                        <div class="name">网关在线</div>
                        <div class="num online"><span>2</span>/2</div>
                    </div>
                </div>
            </div>
            <div class="overviewInverter">
                <div class="title">进线概况</div>
                <div class="inverter">
                    <el-dropdown trigger="click" class="dropdown" @command="handleCommand2" placement="bottom-start">
                        <span class="el-dropdown-link">
                            {{transform2}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item,index) in loopList" :key="index" :command="item">{{item.loopName}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="looptable">
                    <el-table
                        row-class-name="rowName"
                        header-row-class-name="headerName"
                        height="22vh"
                        border
                        :data="details"
                        stripe
                        style="width: 100%">
                        <el-table-column
                        class-name="name"
                        prop="key"
                        align="center">
                            <template slot-scope="scope" >{{ scope.row.key }}<span v-if="scope.row.unit!=''">({{scope.row.unit}})</span></template>
                        </el-table-column>
                        <el-table-column
                        prop="A"
                        align="center"
                        label="A相">
                            <template slot-scope="scope">{{ mqttval(scope.row.A) }}</template>
                        </el-table-column>
                        <el-table-column
                        prop="B"
                        align="center"
                        label="B相">
                        <template slot-scope="scope">{{ mqttval(scope.row.B) }}</template>
                        </el-table-column>
                        <el-table-column
                        prop="C"
                        align="center"
                        label="C相">
                        <template slot-scope="scope">{{ mqttval(scope.row.C) }}</template>
                        </el-table-column>
                        <el-table-column
                        prop="总"
                        align="center"
                        label="总">
                        <template slot-scope="scope">{{ mqttval(scope.row.总) }}</template>
                        </el-table-column>
                    </el-table>
                </div>

            </div>
            <!-- <TodayEvent/> -->
            <div class="statistics EchartsRight">
                <div class="title">用电统计</div>
                <div style="height:21vh;width:100%;">
                    <div class="name">近7日用电量</div>
                    <div id="my_echarts3" style="height:100%;width:100%;margin-top:10rem"> </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {projectTime,diagramDay,GetloopHistorycurve,loopTemperature,loopHistorycurve } from '../../api/common'
    import { getSevenDays,getTodayYesTime,getTodayTime ,getLastOrNextFewDateBy} from '../../util/date'
    import Videoone from "./components/videoone";
    const Href = ()=>import('./components/href.vue')
    const TodayEvent = ()=>import('./components/newComponts/todayEvent.vue')
    const Xialakuang = ()=>import('./components/newComponts/xialakuang.vue')
    import {
        GET_AREAS,
        transformerList
    } from "../../api/power";
    import {
        GET_AREA_LOOPS,
    } from '../../api/common'
    import {
        subscribe,
        unsubscribe,
        subscribeByNodes
    } from "../../mqtt/index";
    import {
        subscribe as alarmSubscribe,
        unsubscribe as alarmUnsubscribe,
    } from "../../mqtt/alarm";
    import { floatFormat } from "../../util/MathUtil";
    import * as echarts from 'echarts';
    export default {
        name: "SubstationManagement",
        props:{
            checkArea:Object
        },
        data() {
            return {
                tabSdx:0,
                isShowArea:false,
                echartsData:[120, 200, 150, 80, 70, 110, 130],
                echartsData2:[12, 20, 15, 8, 7, 11, 13],
                transform:'变压器1',
                transform2:"",
                tableData: [{
                    name: '电流(A)',
                    val1: '123',
                    val2: '123'
                }, {
                   name: '电压(V)',
                    val1: '123',
                    val2: '123'
                }, {
                    name: '功率因数',
                    val1: '123',
                    val2: '123'
                }],
                transformerList:[],
                loopList:[],
                allArea:[],
                AreaInfo:{},
                projectTime:'',
                weekDate:[],
                echartshow:false,
                details: [
                    
                {
                    key: "三相电流",
                    multiple: 0.001,
                    unit: "A",
                    A: "Ia",
                    B: "Ib",
                    C: "Ic",
                    总: "",
                },
                {
                    key: "三相电压",
                    multiple: 0.001,
                    unit: "V",
                    A: "Ua",
                    B: "Ub",
                    C: "Uc",
                    总: "",
                },{
                    key: "功率因数",
                    multiple: 0.001,
                    unit: "",
                    A: "PFa",
                    B: "PFb",
                    C: "PFc",
                    总: "PF",
                },

            ],
                startTime:"" 
            };
        },
        watch: {
            '$store.state.HomePage.currentAreaId'(val){
                
            },
            '$route.query.id'(n,o){
                this.AreaInfo = this.allArea.filter((e) => e.areaId == n)[0];
            },
            transformerList(n,o){
            },
            transform2(n,o){
                this.echartsInit2('my_echarts2');
            }
        },
        computed:{
            mqttval() {
                return this.getMqttVal(this.$store.getters.mqttVal);
            },
            selectLabel() {
                return this.loopList.filter((item) => item.loopName === this.transform2)
            },
        },
        mounted() {
            let that = this
            let d = new Date(this.$store.state.project.projectInfo.deploymentTime)
            this.startTime = d.getFullYear() + "年"+ (d.getMonth() + 1) +"月"+ d.getDate() +"日";
            this.getLoops();
            this.getProjectTime()
            this.$store.commit("Dthere", 2);
            
            this.getLoops();
            this.getTransformerList();
            document.addEventListener('click', this.closePopover);
            GET_AREAS().then(res => {
                this.allArea = res.data.data.areas;
                this.AreaInfo = this.allArea.filter((e) => e.areaId == this.$route.query.id)[0];
            })
        },
        beforeDestroy() {
             document.removeEventListener("click", this.closePopover);
        },
        components: {
            Videoone,Href,TodayEvent,Xialakuang
        },
        methods: {
            getMqttVal(f) {
                let currentLoop = this.loopList.filter(e=>e.loopName==this.transform2)[0]
                // subscribe([currentLoop.subLoopUrl]);
                return (k, m) => {
                    if (currentLoop && k) {
                    k = currentLoop.subLoopUrl + "/" + k;
                    // k = 'T2/Transformer/' + k;
                    let mqttVal = f(k);
                    if (m) {
                        mqttVal *= m;
                        // mqttVal = floatFormat(mqttVal, 1);
                    }
                    mqttVal = floatFormat(mqttVal, 2);

                    if (typeof mqttVal === "object") {
                        return mqttVal;
                    }

                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                    } else {
                    return "--";
                    }
                };
                },
            // 根据区域获取当前的进线再获取三相电流
            async getIntoLine(loop){
                let self = this
                let time = getTodayTime()

                let arr = ['Ia_1h','Ib_1h','Ic_1h']
                let abb = []
                let num = 0
                for(let i = 0;i <arr.length;i++){
                    let data = {
                        deviceLoopId :loop.loopId,
                        node:arr[i],
                        start:`${time.today}T00:00:00Z`,
                        end:`${time.today}T24:00:00Z`
                    }
                    let result = await loopHistorycurve(data)
                    let ia = result.data.data.points.map(item => {
                        return  item = (Number(item.val)).toFixed(2)
                    })
                    this.$set(abb,i,ia)
                    if(ia.length<=0){
                        num ++
                    }
                }
                if(num==3){
                    self.echartshow = true
                }else{
                    self.echartshow = false

                }
                return abb
            },
            async getProjectTime(){
                let res = await projectTime()
                this.projectTime = res.data.data.day
            },
            async getTransformerList() {
                let response = await transformerList("26");
                this.transformerList = response.data.data.list || [];
                this.transform = this.transformerList[0].device_name
                setTimeout(e=>{
                    this.echartsInit('my_echarts');
                    this.echartsInit2('my_echarts2');
                    this.echartsInit3("my_echarts3");
                },100)
            },
            getLoops() {
                GET_AREA_LOOPS("26").then(res => {
                    this.loopList = res.data.data.loops.filter(
                        (item) => item.loopType=="IN"
                    ); 
                    this.loopList.forEach(e=>{
                        subscribe([e.subLoopUrl]);
                    })
                    this.transform2 = this.loopList[0].loopName
                    
                })
            },
            getDistanceSpecifiedTime(dateTime) {
                var EndTime = new Date(dateTime);
                var NowTime = new Date();
                var t = NowTime.getTime() - EndTime.getTime();
                var d = Math.floor(t / 1000 / 60 / 60 / 24);
                return d;
            },
             handleCommand(command) {
                 this.transform = command.device_name
            },
             handleCommand2(command) {
                 this.transform2 = command.loopName
            },
            async echartsInit3(val){
                this.weekDate = getLastOrNextFewDateBy(new Date())
                let arr = []
                let year = new Date().getFullYear()
                let data = {
                    projectId:this.$store.state.project.projectInfo.projectId,
                    start:`${year+'-'+this.weekDate[0].replace("/","-")}T00:00:00Z`,
                    end:`${year+'-'+this.weekDate[6].replace("/","-")}T24:00:00Z`,
                }
                let res = await diagramDay(data)
                // arr = res.data.data.data
                res.data.data.data.forEach(e=>{
                    arr.push(e.toFixed(2))
                })
                
                var chartDom = document.getElementById(val);
                var myChart = echarts.init(chartDom);
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: this.weekDate
                    },
                    yAxis: {
                        type: 'value',
                        name:'kWh'
                    },
                    series: [{
                        data:arr ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5B8FF9',
                            barBorderRadius:[7,7,0,0]
                        }
                    }],
                    grid: {
                        left: "0%",
                        right: "0%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                    
                    tooltip: {
                        trigger: 'axis'
                    },
                })
            },
            changeTab(index,tag){
                this.tabSdx = index
                if(this.tabSdx == 1){
                    this.echartsInit1('my_echarts1');
                }else{
                    this.echartsInit('my_echarts');

                }
            },
            
            closePopover(e){
                let self = this;
                if (self.$refs.area && !self.$refs.area.contains(e.target)) {
                    if (self.isShowArea == true){
                        self.isShowArea = false
                    }
                }
            },
            closedArea(){
                this.isShowArea = false
            },
            // 获取变压器的历史曲线
            async getLoopHistorycurve(transformList){
                let time = getTodayYesTime()
                
                let ydata = {}

                for(let i = 0;i<transformList.length;i++){
                    let data = {
                        deviceLoopId:transformList[i].loop_id,
                        start : `${time.today}T00:00:00Z`,
                        "node": 'P_1h',
                        end : `${time.today}T24:00:00Z`,
                    }
                    let res = await GetloopHistorycurve(data)
                    let points  = res.data.data.points
                    let loopUrl = transformList[i].loop_url.substr(transformList[i].loop_url.indexOf('/') + 1)
                    this.$set(ydata,loopUrl,[])
                    points.forEach(item =>{
                        ydata[loopUrl].push((item.val/1000).toFixed(2))
                    })

                }

                let ydata1 = {}

                for(let i = 0;i<transformList.length;i++){
                    let data = {
                        deviceLoopId:transformList[i].loop_id,
                        start : `${time.yesterday}T00:00:00Z`,
                        "node": 'P_1h',
                        end : `${time.yesterday}T24:00:00Z`,
                    }
                    let res = await GetloopHistorycurve(data)
                    let points  = res.data.data.points
                    let loopUrl = transformList[i].loop_url.substr(transformList[i].loop_url.indexOf('/') + 1)
                    
                    this.$set(ydata1,loopUrl,[])
                    points.forEach(item =>{
                        ydata1[loopUrl].push((item.val/1000).toFixed(2))
                    })
                }
                let obj = {
                    today:ydata,
                    yesterday:ydata1,
                }

                return obj
            },
            // 变压器温度历史曲线 
            async getTransformerTemperature(transformList){
                let time = getTodayTime()
                let that = this
                let T = {}
                
                for(let i = 0;i<transformList.length;i++){
                    let data = {
                        deviceLoopId:transformList[i].loop_id,
                        start : `${time.today}T00:00:00Z`,
                        "node": 'Temperature_1h',
                        end : `${time.today}T24:00:00Z`,
                    }
                    let res = await loopTemperature(data)
                    let loopUrl = transformList[i].loop_url.substr(transformList[i].loop_url.indexOf('/') + 1)
                    
                    that.$set(T, loopUrl,{
                        'A':[],
                        'B':[],
                        'C':[],
                    })

                    let Ta = res.data.data.points.a.map(item =>  item = Number(item.val).toFixed(2))
                    let Tb = res.data.data.points.b.map(item =>  item = Number(item.val).toFixed(2))
                    let Tc = res.data.data.points.c.map(item =>  item = Number(item.val).toFixed(2))
                    
                    T[loopUrl]['A'] = Ta
                    T[loopUrl]['B'] = Tb
                    T[loopUrl]['C'] = Tc

                }
                return T
                
            },
            async echartsInit(val){
                let obj ={}
                if(this.transformerList.length > 0){
                    obj = await this.getLoopHistorycurve(this.transformerList)
                }
                let loop = this.transformerList[0].loop_url.substr(this.transformerList[0].loop_url.indexOf('/') + 1)
                // if(val == )
                let data = obj

                // -------------------------------
                var chartDom = document.getElementById(val);
                var myChart = echarts.init(chartDom);
                let temp = []
                for (let i = 0; i <= 24; i++) {
					temp.push(i + "点")
				}
                var option = {
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 10,
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                        data: [
                            {
                                name: '今日',
                                icon: 'rect',
                            },
                            {
                                name: '昨日',
                                icon: 'rect',
                            }
                        ]
                    },
                    grid: {
                        left: "0%",
                        right: "3%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                   
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:temp
                    },
                    yAxis: {
                        type: 'value',
                        name:val=='my_echarts'?'实时负载':'实时电流',
                        nameTextStyle:{
                            padding: [0,0 ,0,24],
                            fontSize:"16rem",  
                            color:"#333",
                        }
                    },
                    series: [
                        {
                            name: '今日',
                            data:  data.today[loop],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#0D94FF'
                            },
                            areaStyle: {
                                show:false,
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        },
                        {
                            name: '昨日',
                            data:  data.yesterday[loop],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#5AD8A6'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(90,216,166, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        }
                    ]
                }
                
                myChart.clear();
                myChart.setOption(option);
            },
            async echartsInit1(val){
                let obj1 ={}
                if(this.transformerList.length > 0){
                    obj1 = await this.getTransformerTemperature(this.transformerList)
                }
                let loop = this.transformerList[0].loop_url.substr(this.transformerList[0].loop_url.indexOf('/') + 1)
                
                let data = obj1

                // -------------------------------
                let chartDom = document.getElementById("my_echarts1");
                let myChart = echarts.init(chartDom);
                let temp = []
                for (let i = 0; i <= 24; i++) {
					temp.push(i + "点")
				}

                var option ={
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 10,
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                        data: [
                            {
                                name: 'A相',
                                icon: 'rect',
                            },
                            {
                                name: 'B相',
                                icon: 'rect',
                            },
                            {
                                name: 'C相',
                                icon: 'rect',
                            }
                        ]
                    },
                    grid: {
                        left: "0%",
                        right: "3%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                   
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:temp
                    },
                    yAxis: {
                        type: 'value',
                        name:'三相温度',
                        nameTextStyle:{
                            padding: [0,0 ,0,24],
                            fontSize:"16rem",  
                            color:"#333",
                        }
                    },
                    series: [
                        {
                            name: 'A相',
                            data:  data[loop]['A'],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#df375b'
                            },
                            
                        },
                        {
                            name: 'B相',
                            data:  data[loop]['B'],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#ffcd8b'
                            },
                            
                        },
                        {
                            name: 'C相',
                            data:  data[loop]['C'],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#5ad8ce'
                            },
                           
                        },
                    ]
                }
                myChart.clear();
                myChart.setOption(option);
            },
            async echartsInit2(val){
                let obj1 ={}
                let loop = this.selectLabel
                if(this.loopList.length > 0){
                    obj1 = await this.getIntoLine(loop[0])
                }
                // let loop = this.loopList[0].loop_url.substr(this.transformerList[0].loop_url.indexOf('/') + 1)
                let data = obj1
                var chartDom = document.getElementById(val);
                var myChart = echarts.init(chartDom);
                let temp = []
                for (let i = 0; i <= 24; i++) {
					temp.push(i + "点")
				}
                myChart.setOption({
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 10,
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                        data: [
                            {
                                name: 'A相',
                                icon: 'rect',
                            },
                            {
                                name: 'B相',
                                icon: 'rect',
                            },
                            {
                                name: 'C相',
                                icon: 'rect',
                            }
                        ]
                    },
                    grid: {
                        left: "0%",
                        right: "3%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                   
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:temp
                    },
                    yAxis: {
                        type: 'value',
                        name:val=='my_echarts'?'实时负载':'实时电流',
                        nameTextStyle:{
                            padding: [0,0 ,0,24],
                            fontSize:"16rem",  
                            color:"#333",
                        }
                    },
                    series: [
                        {
                            name: 'A相',
                            data:  data[0],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#df375b'
                            },
                        },
                        {
                            name: 'B相',
                            data:  data[1],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#ffcd8b'
                            },
                        },
                        {
                            name: 'C相',
                            data:  data[2],
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#5ad8ce'
                            },
                        },
                    ]
                })
            },
            backYuanqu(){
                this.$router.push('SubstationManagement')
                this.$store.commit("Dthere", 1);
                this.$store.commit("webId", null);

            },
        },
    };
</script>
<style scoped lang="less">
.nodata{
    text-align: center;
    img{
        width: 324rem;
        margin-top: 4vh;
    }
}
.subpostation{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
/deep/.headerName{
    th{
        background: rgba(0, 43, 102, 0.03);
        border-bottom: 0;
        font-size: 16rem;
        color: #333;
        font-weight: 400;
        height: 5vh;
        padding: 0;
    }
}

/deep/.rowName{
    td{
        border-bottom: 0;
        font-size: 16rem;
        color: #0D94FF;
        font-weight: 400;
        height: 5vh;
        padding: 0;
        background: none !important;
    }
    .name{
        color: #333;

    }
    td:nth-child(even){
        background: rgba(0, 43, 102, 0.03) !important;
    }
}
/deep/.headerName {
    background-color: rgba(0, 43, 102, 0.03) !important;
    th{
        background: none;
    }
    th:nth-child(even){
        background: rgba(0, 43, 102, 0.03) !important;
    }
}
/deep/.el-table__row--striped.rowName{
    background: rgba(0, 43, 102, 0.03);
}
/deep/.el-table--border::after, /deep/.el-table--group::after, /deep/.el-table::before{
    content: none;
}
/deep/.el-table--border,/deep/ .el-table--group{
    border: 0;
}
.dropdown.el-dropdown{
    font-size: 18rem !important;
    color: #333;
	cursor: pointer;
    padding: 0 10rem;
}
.looptable{
    table{
        width: 100%;
        td{
            height: 60rem;
            text-align: center;
            font-size: 16rem;
            width: 20%;
        }
        tr:nth-child(odd){
            background: rgba(0, 43, 102, 0.03);
        }
        tr td:nth-child(even){

            background: rgba(0, 43, 102, 0.03);
        }
        .name{
            color: #0D94FF;
        }
    }
}
.statistics{
    height: 29.62962963vh !important;
    .name{
        text-align: center;
        font-size: 18rem;
    }
}
.EchartsLeft,.EchartsRight{
    .w(528);
    background: #ffffff;
    height: 100%;
    padding:20rem 23rem;
    position: relative;
    .capacity{
        color: #999999;
        font-size: 18rem;
        overflow: hidden;
        clear: both;
        position: absolute;
        top: 50rem;
        right: 20px;
    }
    .title{
        font-size: 18rem;
        font-weight: bold;
        margin-bottom: 10rem;
    }
}
    .motion{
        font-size: 18rem;
        text-align: center;
        height: 6vh;
        line-height: 6vh;
        background: rgba(0, 43, 102, 0.04);
        border-radius: 8rem;
        margin-bottom: 33rem;
        span{
            color: #0D94FF;
            font-size: 30rem;
            font-weight: bold;
            vertical-align: -4px;
        }
    }
    .area{
        justify-content: space-between;
        .item{
            // width: 25%;
            text-align: center;
            .name{
                font-size: 18rem;
                height: 30px;
            }
            .num{
                color: #0D94FF;
                font-size: 20rem;
                font-weight: bold;
            }
            
            .online{
                color: #333;
                span{
                    color: #68D86A;
                }
            }
        }
    }
   
</style>